import { forwardRef } from 'react';

import { AlertStatus } from '../entities/alert-status';

export type TaskAlertStatusBadgeProps = { status: AlertStatus };

const TaskAlertStatusBadge = forwardRef<
  HTMLDivElement,
  TaskAlertStatusBadgeProps
>(({ status }, ref) => (
  <div
    ref={ref}
    className="inline-block rounded-full border border-gray-200 px-2 py-1 text-xs font-normal leading-none text-gray-800"
  >
    {status}
  </div>
));

TaskAlertStatusBadge.displayName = 'TaskAlertStatusBadge';
export { TaskAlertStatusBadge };
